import { InjectionToken, Injector } from "@angular/core";
import { BaseService } from "./base.service";
import { HttpClient } from "@angular/common/http";
import { IQueryParams } from "./rest-interfaces";
import { Observable, Observer } from "rxjs";

export const DUMMY_URL = new InjectionToken<string>('DUMMY_URL');
// export const AUTH_API_URL = new InjectionToken<string>('AUTH_API_URL');

export abstract class DummyService<TGet, TPost, TFilter> extends BaseService<TGet, TPost, TFilter> {

    static SUCCESS_STATUS = 'success';
    static FAIL_STATUS = 'fail';

    /**
     * Abstract variable which would be given a value in the derived class.
     * 
     * @abstract
     * @type {string}
     * @memberOf ApiService
     */
    public urlPath: string;

    /**
     * Base url 
     * 
     * @type {string}
     * @memberOf ApiService
     */
    public baseUrl: string = '';

    /**
     * Creates an instance of ApiService.
     * 
     * @param {Http} http
     * @param {Injector} injector
     * 
     * @memberOf ApiService
     */
    constructor(public httpClient: HttpClient, public injector: Injector) {
        super(httpClient);
        this.urlPath = this.getUrl();
        // this.addInterceptor();
    }

    /**
     * Gets the url on which http request has to be made
     * 
     * @returns {string}
     * 
     * @memberOf ApiService
     */
    getUrl(): string {
        //let config: AppConfig = this.iSnjector.get(AppConfig)
        //let baseUrl = 
        this.baseUrl = this.injector.get(DUMMY_URL);
        return this.baseUrl + this.urlPath;
    }

    /**
     * Executes http GET method and returns an observable which returns the collection of data on subscription.
     * 
     * @param {IQueryParams} [queryParams]
     * @param {BaseServiceGetOpt} [options]
     * @returns
     * 
     * @memberOf ApiService
     */
    get(queryParams?: IQueryParams): Observable<any> {
        // console.log("The parameter passed are",queryParams,this.urlPath)
        return Observable.create((observer: Observer<TGet>) => {
            this._get(queryParams).subscribe((response: any) => {
                // console.log("the response from server is", response)
                //const finalResult: any = this.handleFullResponse(response, this.dataModel.ListGet || this.dataModel.Get, options);
                observer.next(response);
            }, (err) => {
                observer.error(err);
            }, () => {
                observer.complete();
            })
        })

    }

    /**
     * Executes http POST method and returns an observable which returns the response on subscription.
     * 
     * @param {*} item
     * @param {IQueryParams} [queryParams]
     * @returns
     * 
     * @memberOf ApiService
     */
    create(item: any, queryParams?: IQueryParams) {
        return Observable.create((observer: Observer<any>) => {
            this._post(item, queryParams).subscribe((response: any) => {
                observer.next(response)
            }, (err) => {
                observer.error(err);
            }, () => {
                observer.complete();
            })
        })
    }
}